























































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
	parseISO,
	addDays,
	set,
	getHours,
	getMinutes,
	format,
	differenceInMinutes,
	isWeekend,
	setDate,
	setMonth, getDate, getMonth, setYear, getYear
} from "date-fns";
import { Circle2 } from "vue-loading-spinner";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';

import shiftModel from "@/models/shift.model";
import shiftKindModel from "@/models/shiftKind.model";
import unitModel from "@/models/unit.model";
import userModel from "@/models/user.model";
import type = Mocha.utils.type;
import {errorObject} from "@/models/crud";
import { getItem } from "@/models/session";
import {QueryFilter} from "@nestjsx/crud-request";

import { Money } from 'v-money';

const MAX_ACTUAL_DURATION_HOURS = 37;

@Component({
	components: { ModalTabs, FormField, Circle2, Money },
})
export default class ShiftModal extends Vue {
	tabs = [
		{ icon: 'edit', name: 'Dados', creation: true },
		{ icon: 'swap_horiz', name: 'Trocar', actionName: 'Confirmar troca', action: this.switchProfessionalUser, permissionType: 'READ_WRITE' },
		{ iconClass: 'fa fa-bullhorn', iconSize: '0.95rem !important', name: 'Anunciar', actionName: () => this.getAnnouncementActionName(), action: this.announceShift, permissionType: 'READ_WRITE' },
		{ icon: 'call_split', name: 'Dividir', actionName: 'Dividir', action: this.splitShift, permissionType: 'READ_WRITE' },
		{ icon: 'playlist_add', name: 'Replicar', actionName: 'Replicar plantão', action: this.copyShift, permissionType: 'READ_WRITE', allowActionWhenReadOnly: true },
		{ icon: 'play_arrow', name: 'Execução', permissionType: 'READ_WRITE' },
		{ icon: 'domain_verification', name: 'Validar', permissionType: 'READ_WRITE' },
		{ icon: 'show_chart', name: 'Relatório' },
		{ icon: 'delete', name: 'Deletar', permissionType: 'READ_WRITE' },
	];
	schema: any = [];
	entity: any = {
		"unit.id": null,
		"sector.id": null,
		"sector.specialty.id": null,
		"priceTable.id": null,
		"professionalUser.id": null,
		"professionalUser.name": "",
		"professionalUser.professionalInfo.professionalDocumentNumber": "",
		"professionalUser.professionalInfo.profession.name": "",
		"pendingProfessionalUser.id": null,
		startDateTime: null,
		netAmount: 0,
		additionalPayment: 0,
		durationTime: null,
		lumpSumPayment: false,
		autoAnnounce: false,
		events: [],
		applications: [],
		startDate: null,
		startTime: null,
		checkInDate: null,
		checkInTime: null,
		checkOutDate: null,
		checkOutTime: null,
		checkInDateTime: null,
		checkOutDateTime: null,
	};
	newProfessionalUserEntity: any = {
		"professionalUser.id": null,
		"professionalUser.professionalInfo.professionalDocumentNumber": "",
		"professionalUser.professionalInfo.profession.name": "",
	}
	copyDates: { dateString: string }[] = [];
	loading = false;
	error = "";
	deletionReasonDetails = "";

	shiftKindModel: any;
	unitModel: any;
	userModel: any;
	totalValue: any = 0;
	displayHourlyAmount: any = 0;
	user: any = { role: "" };

	timeVueMask = '["##:##"]'

	@Prop()
	private shiftId: any;

	constructor() {
		super();
		this.unitModel = unitModel;
		this.userModel = userModel;
		this.shiftKindModel = shiftKindModel;
	}

	private async mounted() {
		this.user = getItem("user") || { role: "" };
		this.loading = true;
		try {
			this.schema = await shiftModel.getDescription();
			if (this.shiftId !== "novo") {
				await this.readEntity(this.shiftId);
			}
		} catch (error) {
			console.error(error);
		}
		if (this.$route.query.unit && this.$route.query.date) {
			this.entity["unit.id"] = parseInt(this.$route.query.unit);
			this.entity.startDateTime = this.$route.query.date;
			this.entity.startDate = this.$route.query.date;
		}
		this.copyDates.push({ dateString: addDays(parseISO(this.entity.startDateTime), 7).toISOString() });
		this.loading = false;
	}

	updateNotes(notes: string) {
		this.entity.auditNotes = notes;
	}

	validateShiftStartDateTime(): boolean {
		if (!this.entity.startDate || !this.entity.startTime) {
			this.$toasted.error('É necessário informar data e hora de início do plantão', { duration: 5000 })
			return false;
		}
		return true;
	}

	validateStartTime(): boolean {
		const [hourString, minuteString] = this.entity?.startTime?.split(':')

		const hour = Number(hourString)
		const minute = Number(minuteString)

		if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
			this.$toasted.error('Horário de início inválido', { duration: 5000 })
			return false;
		}
		return true;
	}

	validateHourlyDurationTime(): boolean {
		if (!this.isHourlyPriceTable) {
			return true;
		}
		if (this.entity.durationTime && !this.entity.durationTime.includes(':')) {
			this.entity.durationTime = `${this.entity.durationTime}:00`;
		}
		if (!this.entity.durationTime || this.getMinutesFromDuration(this.entity.durationTime) <= 0) {
			this.$toasted.error('É necessário informar a duração do plantão para tabela com valor por hora', { duration: 5000 });
			return false;
		}
		return true;
	}

	validateMaxActualDurationTime(): boolean {
		const [durationHours] = this.entity.actualDurationTime ? this.entity.actualDurationTime.split(':') : ["00", "00"];
		if (Number(durationHours) > MAX_ACTUAL_DURATION_HOURS) {
			this.$toasted.error(`Um plantão não deve ter duração maior do que ${MAX_ACTUAL_DURATION_HOURS} horas.`, { duration: 5000 })
			return false;
		}

		return true;
	}

	validateCheckInCheckOutDatetimes(): boolean {
		const durationMinutes = differenceInMinutes(set(parseISO(this.entity.checkOutDateTime), { seconds: 0, milliseconds: 0 }), set(parseISO(this.entity.checkInDateTime), { seconds: 0, milliseconds: 0 }));
		if (durationMinutes <= 0 || !this.entity.actualDurationTime || this.entity.actualDurationTime === '00:00') {
			this.$toasted.error("Data/hora de check-in ou check-out inválidas");
			return false;
		}

		return true
	}

	formatDateTime(rawDate: string, rawTime?: string): Date {
		const parsedStartDate = rawDate ? new Date(rawDate) : new Date();
		const [hour, minute] = rawTime?.includes(':') ? rawTime.split(':') : ['00', '00'];
		const parsedTime = (new Date()).setHours(Number(hour), Number(minute));
		return set(parsedStartDate, { hours: Number(hour), minutes: Number(minute) });
	}

	private async createEntity() {
		try {
			if (!this.validateShiftStartDateTime()) {
				return;
			}
			if (!this.validateStartTime()) {
				return;
			}
			if (!this.validateHourlyDurationTime()) {
				return;
			}
			this.recalculateHourlyAmount();
			const createdShift = await shiftModel.create({
				...this.entity,
				startDateTime: this.formatDateTime(this.entity?.startDate, this.entity?.startTime).toISOString(),
			});
			this.$router.push(`/escalas/calendario/${createdShift?.id}`);
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).clearNotes();
			this.$toasted.success('Plantão inserido com sucesso');
			this.$emit("close");
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Não foi possível realizar a operação. Tente novamente.', { duration: 5000 });
		}
		this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
	}

	private async readEntity(id: number) {
		this.entity = { ...await shiftModel.read(id), events: [], applications: [] };
		this.entity.startDate = this.entity.startDateTime;
		const parsedStartTime = new Date(this.entity.startDateTime);
		this.entity.startTime = format(parsedStartTime, 'HH:mm');
		this.$set(this.entity, 'checkInDate', this.entity.checkInDateTime);
		this.$set(this.entity, 'checkOutDate', this.entity.checkOutDateTime);
		const parsedCheckInTime = this.entity.checkInDateTime ? format(new Date(this.entity.checkInDateTime), 'HH:mm') : null;
		const parsedCheckOutTime = this.entity.checkOutDateTime ? format(new Date(this.entity.checkOutDateTime), 'HH:mm') : null;
		this.$set(this.entity, 'checkInTime', parsedCheckInTime);
		this.$set(this.entity, 'checkOutTime', parsedCheckOutTime);

		if (this.entity["unit.id"]) {
			const unitWithPriceTables = await unitModel.read(this.entity["unit.id"], "priceTables");
			this.unitPriceTables = unitWithPriceTables.priceTables;
			this.updateDisplayHourlyAmount();
			if (this.isHourlyPriceTable) {
				this.recalculateHourlyAmount();
			}
			this.totalValueCalculation();
		}

		this.entity.events = (await shiftModel.read(id, "events", ["address", "bankAccount", "professionalInfo", "personalInfo", "Sectors"] )).events;
		this.entity.changeLogs = (await shiftModel.read(id, "changeLogs", ["user"] )).changeLogs;
		const { applications } = (await shiftModel.read(id, "applications", ["address", "bankAccount", "professionalInfo", "personalInfo"] ));
		this.entity.applications = applications.sort((a: any, b: any) => a.createdDate > b.createdDate ? 1 : -1);
		this.newProfessionalUserEntity["professionalUser.id"] =  this.entity["pendingProfessionalUser.id"];
	}

	private isPersistedShiftBillingLocked(persistedShift: any) {
		return ['PAID', 'BILLED'].includes(persistedShift?.state);
	}

	private async refreshEntityBeforeManualUpdate() {
		const persistedShift = await shiftModel.read(this.entity.id);
		if (this.isPersistedShiftBillingLocked(persistedShift)) {
			await this.readEntity(this.entity.id);
			this.$toasted.error('Plantões pagos ou faturados não podem ser editados manualmente');
			return false;
		}
		return true;
	}

	private async updateEntity(successMessage = 'Plantão atualizado com sucesso') {
		if (this.isFinanciallyLocked) {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		try {
			if (this.isBillingLocked || !(await this.refreshEntityBeforeManualUpdate())) {
				return;
			}
			// fix durations without colon separator
			if (this.entity.overtimeDuration?.indexOf(":") < 0) {
				this.entity.overtimeDuration += ":00";
			}
			if (this.entity.latenessDuration?.indexOf(":") < 0) {
				this.entity.latenessDuration += ":00";
			}
			// removed checkIn or checkOut date in case it's an empty string
			this.entity.checkInDateTime = this.entity.checkInDateTime === '' ? undefined : this.entity.checkInDateTime;
			this.entity.checkOutDateTime = this.entity.checkOutDateTime === '' ? undefined : this.entity.checkOutDateTime;

			/**
			 * In case only checkIn date and time is being informed AND state is PENDING
			 * we considered the desired action to be a shift check in
			 */
			if (this.entity.checkInDateTime && !this.entity.checkOutDateTime && this.entity.state === 'PENDING') {
				this.entity.state = 'IN_PROGRESS'
			}

			if (this.entity.checkInDateTime && this.entity.checkOutDateTime && (this.entity.state === 'IN_PROGRESS' || this.entity.state === 'PENDING')) {
				this.entity.state = 'COMPLETED'
			}

			if (this.entity.state === 'COMPLETED' && !this.validateCheckInCheckOutDatetimes()) {
				return;
			}

			if (this.entity.state === 'COMPLETED' && !this.validateMaxActualDurationTime()) {
				return;
			}

			if (!this.validateShiftStartDateTime()) {
				return;
			}
			if (!this.validateStartTime()) {
				return;
			}
			if (!this.validateHourlyDurationTime()) {
				return;
			}
			this.recalculateHourlyAmount();

			await shiftModel.update(this.entity.id, {
				...this.entity,
				startDateTime: this.formatDateTime(this.entity?.startDate, this.entity?.startTime).toISOString(),
			});

			this.$toasted.success(successMessage);
			await this.readEntity(this.entity.id);

			if (this.entity.autoAnnounce && this.entity.state !== "ANNOUNCED") {
				await shiftModel.announce(this.entity.id, this.entity.auditNotes);
				this.$toasted.success("Plantão anunciado");
			}
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Não foi possível atualizar. Tente novamente.');
		} finally {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
		}
	}

	handleCopyDateDeleteClick(dateIndex: number) {
		this.copyDates.splice(dateIndex, 1);
	}

	private async deleteEntity() {
		const closedStates = ['COMPLETED', 'BILLED', 'PAID', 'FAILED'];
		const isClosedState = closedStates.includes(this.entity.state);

		if (isClosedState && !this.entity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}

		if (isClosedState && this.entity.deletionReason === 'Outra (descrever abaixo)' && !this.deletionReasonDetails.trim()) {
			this.$toasted.error('Por favor, descreva o motivo da exclusão');
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}

		try {
			const auditNotes = isClosedState
				? `Justificativa: ${this.entity.deletionReason === 'Outra (descrever abaixo)' ? this.deletionReasonDetails : this.entity.deletionReason}\n${this.entity.auditNotes || ''}`
				: this.entity.auditNotes || '';

			await shiftModel.deleteShift(this.entity.id, auditNotes);
			this.$toasted.success('Plantão excluído com sucesso');
			this.$emit('close');
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Não foi possível excluir. Verifique sua permissão e tente novamente.');
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
		}
	}

	get isCreation() {
		return this.shiftId === 'novo';
	}

	get canEditCompletedManually() {
		return ['COORDINATOR', 'COORDINATOR2', 'MASTER', 'MASTER2'].includes(this.user.role);
	}

	get canEditStateManually() {
		return this.canEditCompletedManually;
	}

	get isBillingLocked() {
		return ['PAID', 'BILLED'].includes(this.entity.state);
	}

	get canEditNonBillingFields() {
		if (this.isBillingLocked) {
			return false;
		}
		if (this.entity.state === 'COMPLETED') {
			return this.canEditCompletedManually;
		}
		return true;
	}

	get isReadOnly() {
		return this.isBillingLocked;
	}

	get isFinanciallyLocked() {
		return this.isBillingLocked;
	}

	get canCompleteShift() {
		return !this.isFinanciallyLocked && ['PENDING', 'IN_PROGRESS', 'FAILED', 'COMPLETED'].includes(this.entity.state);
	}

	get selectedPriceTableEntity() {
		if (!this.entity["priceTable.id"] || !this.unitPriceTables.length) return null;
		return this.unitPriceTables.find((pt: any) => pt.id === this.entity["priceTable.id"]) || null;
	}

	get isHourlyPriceTable() {
		return this.selectedPriceTableEntity?.pricingType === 'HOURLY';
	}

	updateDisplayHourlyAmount() {
		this.displayHourlyAmount = this.selectedPriceTableEntity?.hourlyAmount || 0;
	}

	// -- Specialty, sector and professional filters
	unitSectors: any = [];
	unitPriceTables: any = [];
	specialtyOptions: any = [];
	sectorOptions: any = [];

	get availableUnitPriceTables() {
		return this.unitPriceTables;
	}

	get stateOptions() {
		const stateFieldDescription = this.schema.find((field: any) => field.key === "state");
		const options = stateFieldDescription?.options || [];
		return options.filter((option: any) => !["BILLED", "PAID"].includes(option.value));
	}

	get selectedUnit() {
		return this.entity["unit.id"];
	}
	@Watch("selectedUnit")
	async unitSelected(unitId: any) {
		if (!unitId) {
			return;
		}
		const unitWithSectors = await unitModel.read(unitId, "unitSectors", ["userSectors", "coordinatedSectors"]);
		this.unitSectors = unitWithSectors.unitSectors;
		const unitWithPriceTables = await unitModel.read(unitId, "priceTables", [], this.applyPriceTableAvailabilityFilters());
		this.unitPriceTables = unitWithPriceTables.priceTables;
		this.validateSelectedPriceTableAvailability();
		const specialtiesObject = Object.fromEntries(this.unitSectors.map((unitSector: any) => [unitSector["sector.specialty.id"], unitSector["sector.specialty.name"]]));
		this.specialtyOptions = Object.entries(specialtiesObject).map(([id, name]) => ({ id: parseInt(id), name }));
		if (this.selectedSpecialty) { // force load sector options
			this.specialtySelected(this.selectedSpecialty);
		}
	}

	get selectedStartDateTime() {
		return this.entity["startDateTime"];
	}
	@Watch("selectedStartDateTime")
	async startDateTimeSelected() {
		const unitWithPriceTables = await unitModel.read(this.entity["unit.id"], "priceTables", [], this.applyPriceTableAvailabilityFilters());
		this.unitPriceTables = unitWithPriceTables.priceTables;
		this.validateSelectedPriceTableAvailability();
	}

	applyPriceTableAvailabilityFilters(): Array<QueryFilter> {
		const chosenStartDateTime = parseISO(this.entity.startDateTime);
		const isChosenStartDateTimeWeekend = isWeekend(chosenStartDateTime);
		return isChosenStartDateTimeWeekend ? [{ field: "priceTables.weekendAvailable", operator: "eq", value: "1" }] : [{ field: "priceTables.weekAvailable", operator: "eq", value: "1" }];
	}

	validateSelectedPriceTableAvailability() {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (!this.entity["priceTable.id"]) {
			return;
		}
		if (this.unitPriceTables.find((priceTable: any) => priceTable.id === this.entity["priceTable.id"])) {
			return;
		}
		this.entity["priceTable.id"] = null;
		this.entity.netAmount = 0;
		this.entity.grossAmount = 0;
		this.displayHourlyAmount = 0;
		this.totalValueCalculation();
	}

	get selectedSpecialty() {
		return this.entity["sector.specialty.id"];
	}
	@Watch("selectedSpecialty")
	async specialtySelected(specialtyId: any) {
		this.sectorOptions = this.unitSectors.filter((unitSector: any) => unitSector["sector.specialty.id"] == specialtyId).map((unitSector: any) => ({ id: unitSector["sector.id"], name: unitSector["sector.name"] }));
	}

	get userFilter() {
		if (this.entity["sector.id"]) {
			return { "userSectors.sector": { $eq: this.entity["sector.id"] } };
		}

		if (this.entity["sector.specialty.id"]) {
			return { "userSectors.sector.specialty": { $eq: this.entity["sector.specialty.id"] } };
		}

		return {};
	}

	get selectedUser() {
		return this.entity["professionalUser.id"];
	}
	@Watch("selectedUser")
	async userSelected(userId: any)  {
		if (!userId) {
			return;
		}
		const user = await userModel.read(userId);
		this.entity["professionalUser.professionalInfo.professionalDocumentNumber"] = user["professionalInfo.professionalDocumentNumber"];
		this.entity["professionalUser.professionalInfo.profession.name"] = user["professionalInfo.profession.name"];
	}

	get selectedPriceTable() {
		return this.entity["priceTable.id"];
	}
	@Watch("selectedPriceTable")
	async priceTableSelected(priceTableId: any, priceTableIdOld: any) {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (!priceTableId) {
			return;
		}
		if (this.entity.netAmount && this.entity.durationTime && !priceTableIdOld) { // don't overwrite while reading entity
			const existingPriceTable = this.unitPriceTables.find((pt: any) => pt.id === priceTableId);
			this.updateDisplayHourlyAmount();
			if (existingPriceTable?.pricingType === 'HOURLY') {
				this.recalculateHourlyAmount();
			}
			this.totalValueCalculation();
			return;
		}
		if (this.unitPriceTables.length) {
			const priceTable = this.unitPriceTables.find((priceTable: any) => priceTable.id === priceTableId);
			if (!priceTable) {
				return;
			}
			this.updateDisplayHourlyAmount();
			if (priceTable.pricingType === 'HOURLY') {
				this.recalculateHourlyAmount();
				return;
			}
			this.displayHourlyAmount = 0;
			this.entity.netAmount = priceTable.netAmount;
			this.entity.durationTime = priceTable.durationTime;
			this.entity.grossAmount = priceTable.grossAmount;
			this.recalculateExecutionAmounts();
			this.totalValueCalculation();
		}
	}

	@Watch("entity.durationTime")
	@Watch("selectedPriceTableEntity.hourlyAmount")
	recalculateHourlyAmount() {
		if (this.isFinanciallyLocked) return;
		if (!this.isHourlyPriceTable) return;
		if (!this.selectedPriceTableEntity) return;
		if (!this.entity.durationTime) {
			this.entity.netAmount = 0;
			this.recalculateExecutionAmounts();
			return;
		}
		// Normaliza duração: "12" -> "12:00", "12:30" -> "12:30"
		let durationTime = this.entity.durationTime;
		if (!durationTime.includes(":")) {
			durationTime = `${durationTime}:00`;
			this.entity.durationTime = durationTime;
		}
		const parts = durationTime.split(":");
		const hours = parseInt(parts[0] || "0", 10);
		const minutes = parseInt(parts[1] || "0", 10);
		const totalHours = hours + minutes / 60;
		const hourlyAmount = this.selectedPriceTableEntity.hourlyAmount || 0;
		this.entity.netAmount = Math.round(totalHours * hourlyAmount * 100) / 100;
		this.recalculateExecutionAmounts();
	}

	// Overtime and lateness amount calculation
	getMinutesFromDuration(duration: string) {
		const durationParts = duration?.split(":");
		return durationParts ? parseInt(durationParts[0] || "0") * 60 + parseInt(durationParts[1] || "0") : 0;
	}

	getAmountPerMinute() {
		return (this.entity.netAmount || 0) / (this.getMinutesFromDuration(this.entity.durationTime) || 1);
	}

	recalculateExecutionAmounts() {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (!this.entity.actualDurationTime || !this.entity.durationTime) {
			this.entity.overtimeDuration = '00:00';
			this.entity.overtimeAmount = 0;
			this.entity.latenessDuration = '00:00';
			this.entity.latenessAmount = 0;
			this.totalValueCalculation();
			return;
		}

		const actualDurationMinutes = this.getMinutesFromDuration(this.entity.actualDurationTime);
		const expectedDurationMinutes = this.getMinutesFromDuration(this.entity.durationTime);
		const durationDifferenceMinutes = actualDurationMinutes - expectedDurationMinutes;
		const absoluteDifferenceMinutes = Math.abs(durationDifferenceMinutes);
		const differenceDuration = `${Math.floor(absoluteDifferenceMinutes / 60).toString().padStart(2, '0')}:${Math.floor(absoluteDifferenceMinutes % 60).toString().padStart(2, '0')}`;

		if (durationDifferenceMinutes > 0) {
			this.entity.overtimeDuration = differenceDuration;
			this.entity.overtimeAmount = absoluteDifferenceMinutes * this.getAmountPerMinute();
			this.entity.latenessDuration = '00:00';
			this.entity.latenessAmount = 0;
		} else if (durationDifferenceMinutes < 0) {
			this.entity.latenessDuration = differenceDuration;
			this.entity.latenessAmount = absoluteDifferenceMinutes * this.getAmountPerMinute();
			this.entity.overtimeDuration = '00:00';
			this.entity.overtimeAmount = 0;
		} else {
			this.entity.overtimeDuration = '00:00';
			this.entity.overtimeAmount = 0;
			this.entity.latenessDuration = '00:00';
			this.entity.latenessAmount = 0;
		}
		this.totalValueCalculation();
	}


	// Professional user switch
	get selectedNewUser() {
		return this.newProfessionalUserEntity["professionalUser.id"];
	}
	@Watch("selectedNewUser")
	async newUserSelected(userId: any)  {
		if (!userId) {
			return;
		}
		const user = await userModel.read(userId);
		this.newProfessionalUserEntity["professionalUser.professionalInfo.professionalDocumentNumber"] = user["professionalInfo.professionalDocumentNumber"];
		this.newProfessionalUserEntity["professionalUser.professionalInfo.profession.name"] = user["professionalInfo.profession.name"];
		this.newProfessionalUserEntity["professionalUser.name"] = user["name"];
	}

	private async switchProfessionalUser() {
		if (this.isFinanciallyLocked) {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		if (!this.newProfessionalUserEntity["professionalUser.id"]) {
			this.$toasted.error("Selecione o novo profissional");
			return;
		}
		if (this.newProfessionalUserEntity["professionalUser.id"] === this.entity["professionalUser.id"]) {
			this.$toasted.error("Selecione um profissional diferente do atual");
			return;
		}
		try {
			await shiftModel.changeProfessionalUser(this.entity.id, this.newProfessionalUserEntity["professionalUser.id"], this.entity.auditNotes);
			this.$toasted.success("Troca efetuada com sucesso");
			this.$emit("close")
		} catch (error) {
			console.error(error);
			error.friendlyMessage = errorObject[error?.message]
			this.$toasted.error(error.friendlyMessage || 'Não foi possível atualizar. Tente novamente.', { duration: 5000 });
		} finally {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
		}
	}

	// Shift announcement
	private async announceShift() {
		if (this.isFinanciallyLocked) {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		try {
			if (this.entity.state !== "ANNOUNCED") {
				this.entity.state = (await shiftModel.announce(this.entity.id, this.entity.auditNotes)).state;
				this.$toasted.success("Plantão anunciado com sucesso");
			} else {
				this.entity.state = (await shiftModel.disableAnnouncement(this.entity.id, this.entity.auditNotes)).state;
				this.$toasted.success("Anúncio retirado com sucesso");
			}
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || "Não foi possível atualizar. Tente novamente.");
		}
		this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
	}

	getAnnouncementActionName() {
		return this.entity.state === "ANNOUNCED" ? "Retirar anúncio" : "Anunciar plantão";
	}

	respondingApplication = false;
	private async respondApplication(application: any, response: "ACCEPT" | "REFUSE") {
		if (this.isFinanciallyLocked) {
			this.respondingApplication = false;
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		if(!(await EspressoAux.showConfirmationModal(`Confirma ${response === 'ACCEPT' ? 'o aceite' : 'a recusa'}?`, "Não será possível desfazer essa ação.")).value) {
			return;
		}
		this.respondingApplication = true;
		try {
			await shiftModel.respondApplication(this.entity.id, application["user.id"], response, this.entity.auditNotes);
			await this.readEntity(this.entity.id);
			await this.userSelected(this.entity["professionalUser.id"]);
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao atualizar a candidatura. Tente novamente.");
		}
		this.respondingApplication = false;
	}

	// Shift split
	private async splitShift() {
		if (this.isFinanciallyLocked) {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		// fix duration without colon separator
		if (this.entity.splitDuration?.indexOf(":") < 0) {
			this.entity.splitDuration += ":00";
		}
		if(!(await EspressoAux.showConfirmationModal(`Confirma a divisão?`, "Não será possível desfazer essa ação.")).value) {
			this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			return;
		}
		try {
			await shiftModel.split(this.entity.id, this.entity.splitDuration, this.entity.auditNotes);
			this.$toasted.success("Plantão dividido com sucesso");
			this.$emit("close");
		} catch (error) {
			console.error(error);
			this.$toasted.error("Não foi possível dividir. Verifique o estado do plantão.");
		}
		this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
	}

	// Shift copy
	private addCopyDate() {
		if (this.copyDates.length) {
			const dateString = addDays(parseISO(this.copyDates[this.copyDates.length - 1].dateString), 7).toISOString();
			this.copyDates.push({ dateString });
		}
	}

	private async copyShift() {
		// CORREÇÃO: Usar startTime (formato HH:mm) em vez de extrair de startDateTime
		// que pode ter perdido a informação de hora ao ser salvo no banco
		const [hours, minutes] = this.entity.startTime?.split(':') || ['00', '00'];
		const shiftHoursMinutes = {
			hours: Number(hours),
			minutes: Number(minutes),
		};
		const startDateTimes = this.copyDates.map(date => set(parseISO(date.dateString), shiftHoursMinutes).toISOString());
		const shifts = startDateTimes.map(startDateTime => ({
			...this.entity,
			id: null,
			startDateTime,
			state: this.entity["professionalUser.id"] ? 'PENDING' : 'STANDBY',
			checkInDateTime: null,
			checkOutDateTime: null,
			actualDurationTime: null,
			events: [],
			attendanceStatus: undefined,
		}));

		for (let shift of shifts) {
			try {
				await shiftModel.create(shift);
				this.$toasted.success(`Plantão replicado para o dia ${format(parseISO(shift.startDateTime), "dd/MM/yyyy")}`);
			} catch (error) {
				error.friendlyMessage = errorObject[error?.message]
				if (error?.friendlyMessage) {
					this.$toasted.error(error.friendlyMessage, { duration: 5000 });
				}
				this.$toasted.error(`Ocorreu um erro ao replicar para o dia ${format(parseISO(shift.startDateTime), "dd/MM/yyyy")}`);
				console.error(error);
			} finally {
				this.$refs.modalTabs && (this.$refs.modalTabs as ModalTabs).actionCompleted();
			}
		}
	}

	// Shift execution (check-in and check-out)
	@Watch("entity.checkInDateTime")
	@Watch("entity.checkOutDateTime")
	updateActualDurationTime() {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (!this.entity.checkInDateTime || !this.entity.checkOutDateTime) {
			return;
		}
		const parsedCheckOutDateTime = set(new Date(this.entity.checkOutDateTime), { seconds: 0, milliseconds: 0 });
		const parsedCheckInDateTime = set(new Date(this.entity.checkInDateTime), { seconds: 0, milliseconds: 0 });

		// @ts-ignore
		const durationMinutes = (parsedCheckOutDateTime - parsedCheckInDateTime) / 1000 / 60;

		// const durationMinutes = differenceInMinutes(set(parseISO(this.entity.checkOutDateTime), { seconds: 0, milliseconds: 0 }), set(parseISO(this.entity.checkInDateTime), { seconds: 0, milliseconds: 0 }));
		if (durationMinutes <= 0) {
			this.$toasted.error("Data/hora de check-in ou check-out inválidas");
			return;
		}

		const hours = Math.floor(durationMinutes / 60).toString().padStart(2, "0");
		const minutes = Math.floor(durationMinutes % 60).toString().padStart(2, "0");

		this.entity.actualDurationTime = `${hours}:${minutes}`;
		this.recalculateExecutionAmounts();
	}

	private async completeShift() {
		if (this.isFinanciallyLocked) {
			return;
		}
		const unitSector = this.unitSectors?.find((sector: any) => sector["sector.id"] === this.entity["sector.id"] && sector["sector.specialty.id"] === this.entity["sector.specialty.id"]);

		if (unitSector?.checkInEnabled && (!this.entity.checkInDateTime || !this.entity.checkOutDateTime)) {
			this.$toasted.error("A unidade exige horário de check-in e check-out para esta especialidade.");
			return;
		}

		if (!this.validateCheckInCheckOutDatetimes()) return;

		if (!["PENDING", "IN_PROGRESS", "FAILED", "COMPLETED"].includes(this.entity.state)) {
			this.$toasted.error("O plantão não pode ser finalizado em seu estado atual.");
			return;
		}

		if (!(await EspressoAux.showConfirmationModal("Confirma a finalização?", "O plantão será marcado como Realizado. Não será possível desfazer essa ação.")).value) {
			return;
		}

		try {
			this.entity.state = "COMPLETED";
			await this.updateEntity("Plantão finalizado com sucesso");
			await this.readEntity(this.entity.id);
		} catch (error) {
			console.error(error);
			this.$toasted.error("Erro ao finalizar plantão. Verifique se ele já foi concluído.");
		}
	}

	// Report helpers
	private formatDate(date: any) {
		return format(parseISO(date), "dd/MM/yyyy HH:mm");
	}

	private formatAction(action: any) {
		const options = this.schema.find((field: any) => field.key === "events.action").options;
		return options.find((field: any) => field.value === action).name;
	}

	// Total value calculation on validation
	@Watch("entity.netAmount")
	@Watch("entity.latenessAmount")
	@Watch("entity.overtimeAmount")
	@Watch("entity.additionalPayment")
	async totalValueCalculation() {
		if (this.isFinanciallyLocked) {
			return;
		}
		this.totalValue = parseFloat(this.entity?.netAmount || 0) + parseFloat(this.entity?.overtimeAmount || 0) - parseFloat(this.entity?.latenessAmount || 0) + parseFloat(this.entity?.additionalPayment || 0);

		if (this.totalValue < 0) {
			this.totalValue = 0
		}
	}

	@Watch("entity.checkInDate")
	@Watch("entity.checkInTime")
	async updateCheckInDateTime() {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (this.entity?.checkInDate && this.entity?.checkInTime?.includes(':')) {
			this.entity.checkInDateTime = this.formatDateTime(this.entity?.checkInDate, this.entity?.checkInTime).toISOString();
		}
	}

	@Watch("entity.checkOutDate")
	@Watch("entity.checkOutTime")
	async updateCheckOutDateTime() {
		if (this.isFinanciallyLocked) {
			return;
		}
		if (this.entity?.checkOutDate && this.entity?.checkOutTime?.includes(':')) {
			this.entity.checkOutDateTime = this.formatDateTime(this.entity?.checkOutDate, this.entity?.checkOutTime).toISOString();
		}
	}
}
